export const vulnSources = [
  'anchore-apk',
  'anchore-deb',
  'anchore-rpm-generic',
  'backfill',
  'fossa',
  'FOSSA',
  'fossa-ext',
  'github-security',
  'magento-security-advisories',
  'nodesecurity',
  'nvd',
  'nvdGithubAssoc',
  'ossindex',
  'pythonSecurityAdvisory',
  'retire.js',
  'ruby-advisory-db',
  'rustsec',
  'sensiolabs-security-advisories',
  'victims-cve-db',
  'sparkle',
] as const;

export type VulnSource = (typeof vulnSources)[number];
